<template>
  <div class="procurementBidding wrapper .ccui-navigation">
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div class="ccui-tree-table">
      <div class="ccui-tree-wrapper">
        <div class="dic-box">
          <span class="dic-left">栏目导航</span>
        </div>
        <div class="ccui-tree">
          <el-tree
            v-if="showTree"
            style="width: 220px; margin-left: 20px;"
            class="parent-tree flow-tree"
            ref="tree"
            :load="loadNode"
            :props="treeProps"
            node-key="faqClassifyId"
            :check-strictly="true"
            lazy
            highlight-current
            :default-expanded-keys="expendedIdArr"
            :draggable="draggable"
            @node-expand="nodeExpand"
            @node-collapse="nodeCollapse"
            @node-click="nodeClickHandler"
            @node-drop="nodeDrop"
            :allow-drop="allowDrop"
          >
          </el-tree>
        </div>
      </div>
      <div class="ccui-app-container">
        <div
          class="ccui-advanced-search-wrapper ccui-clearfix"
          v-if="!isShowDetail"
        >
          <div class="ccui-search-wrapper">
            <div class="ccui-tab-wrapper">
              <el-button type="table-top-active" size="mini">全部</el-button>
            </div>
          </div>
          <div class="dic-content">
            <ul>
              <li
                class="detail-title"
                v-for="(item, index) in dicArr"
                :key="index"
                @click="showDetail(item.faqId)"
              >
                <span class="doct">.</span>
                <span :title="item.faqName">{{ item.faqName }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div
          class="ccui-advanced-search-wrapper ccui-clearfix"
          v-if="!isShowDetail"
        >
          <!-- 暂时写反，要改 -->
          <div class="dic-view">
            <div class="title-box">
              <span class="content-title" :title="faqProblemBO.faqName">
                {{ faqProblemBO.faqName }}
              </span>
            </div>
            <div class="little-title">
              <span>发布时间 {{ faqProblemBO.publishTime }}</span>
              <span>阅读量 {{ faqProblemBO.readingCnt }}</span>
              <span>责任编辑 {{ faqProblemBO.publishUser }}</span>
              <span
                class="edit-content"
                @click="handleEditQuestion(faqProblemBO.faqId)"
              >
                <i class="icon-ccui-edit"></i>
                <span> 编辑正文</span>
              </span>
            </div>
            <div class="content-detail" v-html="faqProblemBO.textContent"></div>
          </div>
        </div>
        <div class="content-text" v-if="dicArr.length == 0">
          <!-- <img
            src="../../../assets/images/content_null.png"
            class="content-null-image"
            alt
          /> -->
          <p class="content-null-text">暂无相关数据</p>
        </div>
      </div>
      <!-- <help-edit-dialog
        @dialogFormTrueMain="dialogFormTrueMain"
        ref="editFormVisible"
      ></help-edit-dialog>
      <help-question-dialog
        @questionDialog="questionDialog"
        ref="questionFormVisible"
      ></help-question-dialog> -->
    </div>
  </div>
</template>

<script>
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
export default {
  name: "procurementBidding",
  components: {
    baseBreadCrumb
  },
  data() {
    return {
      currBreadCrumb: [{ title: "采购招标" }, { title: "更多 >" }],
      showTree: true,
      isShowDetail: false,
      faqClassifyId: "",
      treeProps: {
        label: "title",
        isLeaf: "isLeafNode",
        children: "treeList"
      },
      draggable: false,
      dicArr: [],
      expendedIdArr: [69],
      faqProblemBO: {
        faqName: "",
        publishTime: "",
        readingCnt: "",
        publishUser: "",
        faqId: "",
        textContent: ""
      }
    };
  },
  methods: {
    /* queryFaqClassifyTree() {
      const obj = {
        appUId: APPUID,
        titleCode: this.titleCode || ""
      };
      return queryFaqClassifyTree(obj);
    }, */
    loadNode(node, resolve) {
      this.level = node.level;
      this.resolve = resolve;
      if (node.level < 1) {
        this.isNewDisabled = true;
        /* this.queryFaqClassifyTree().then(res => {
          console.log(res);
          if (res.data.code == "0") {
            if (res.data.data.treeList.length < 1) {
              this.btnTxt = "新建";
              this.isNewDisabled = true;
            } else if (this.btnTxt == "完成") {
              this.btnTxt = "完成";
            } else if (this.btnTxt == "编辑") {
              this.btnTxt = "编辑";
            }
            if (res.data.data.treeList.length > 0) {
              if (this.first == 0) {
                //只有第一次加载数时默认展开第一个节点，以后修改根节点时，已经展开哪些仍然展开哪些，所以不再走此代码
                this.expendedIdArr = [];
                this.expendedIdArr.push(
                  res.data.data.treeList[0].faqClassifyId
                );
              }
              console.log(this.expendedIdArr);
              this.first++;
              this.$refs.tree.setCurrentKey(
                res.data.data.treeList[0].faqClassifyId
              );

              console.log(this.expendedIdArr);
            }
            resolve(res.data.data.treeList);
          } 
        });*/
      }
    },
    nodeExpand(obj, node, el) {
      this.expendedIdArr.push(obj.faqClassifyId);
    },
    nodeDrop(draggingNode, dropNode, dropType, ev) {
      /*const obj = {
        faqClassifyStartId: this.draggingNodeId,
        faqClassifyEndId: this.dropNodeId
      };
       updateFaqClassifySort(obj).then(res => {
        console.log(res);
      }); */
    },
    handleNewDic(node) {
      let selfTitleCode = node.data.titleCode;
      if (node.level == 1) {
        this.titleCode = "";
      } else {
        this.titleCode = node.data.titleCode;
      }
      this.treeNode = node;
      this.parentTitleCode = node.data.parentTitleCode;
      this.levelNode = node.data.level; //单击的节点级别
      if (node.parent.data) {
        this.parentTitle = node.parent.data.title;
      } else {
        this.parentTitle = "";
      }
      this.type = 0;
      this.$refs["editFormVisible"].dialogFormVisible = true;
      this.$refs["editFormVisible"].supplierType(
        this.levelNode,
        this.type,
        this.parentTitleCode,
        this.parentTitle,
        selfTitleCode
      );
    },
    nodeClickHandler(obj, node) {
      this.faqClassifyName = "";
      this.faqProblemBO.textContent = "";
      if (node.data.level > 1) {
        this.isNewDisabled = false;
      } else {
        this.isNewDisabled = true;
      }
      this.faqClassifyId = node.data.faqClassifyId;
      this.faqClassifyIdNew = node.data.faqClassifyId;
      this.treeNode = node;
      this.treeData = obj;
      this.parentTitleCode = node.data.parentTitleCode;
      this.isShowDetail = false;
      this.queryFaqProblemList(obj.faqClassifyId);
    },
    nodeCollapse(obj, node, el) {
      const index = this.expendedIdArr.findIndex(
        value => value == obj.faqClassifyId
      );
      this.expendedIdArr.splice(index, 1);
    },
    allowDrop(draggingNode, dropNode, type) {
      console.log(
        "source:",
        draggingNode.data.parentTitleCode,
        "mudi:",
        dropNode.data.parentTitleCode
      );
      this.draggingNodeId = draggingNode.data.faqClassifyId;
      this.dropNodeId = dropNode.data.faqClassifyId;
      console.log("level:", draggingNode.level, dropNode.level);
      if (
        (draggingNode.level == 1 && dropNode.level == 1) ||
        (draggingNode.level == 2 &&
          dropNode.level == 2 &&
          draggingNode.data.parentTitleCode == dropNode.data.parentTitleCode)
      ) {
        return type === "prev" || type === "next";
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/config/styles/question-edit.scss";
</style>
